import type { StatusTone } from "@/components/StatusChip";

/** Product status → colour + word (design/04 §0): green "On sale", grey "Draft", grey "Archived". */
export function productStatusTone(status: string): { tone: StatusTone; labelKey: string } {
  switch (status) {
    case "active":
      return { tone: "active", labelKey: "products:status.active" };
    case "draft":
      return { tone: "draft", labelKey: "products:status.draft" };
    case "archived":
      return { tone: "draft", labelKey: "products:status.archived" };
    default:
      return { tone: "info", labelKey: "products:status.other" };
  }
}
